import { TOKEN } from './../../const';
import { setValue, removeValue } from './../../utils';
import { IRootState, client, createUIError } from '@/store';
import { BASE_URL } from '@/const';
import { Module } from 'vuex';
import { IUser, Maybe } from '@/models';

export interface IUserState {
  token: Maybe<string>;
  currentUser: Maybe<IUser>;
  error: boolean;
}

export interface LoginResponse {
  token: string;
}

export interface ALoginParams {
  email: string;
  password: string;
}

export const user: Module<IUserState, IRootState> = {
  namespaced: true,
  state: {
    currentUser: null,
    token: undefined,
    error: false,
  },
  actions: {
    async login({ commit, dispatch }, { email, password }: ALoginParams) {
      commit('setError', false);
      try {
        const {
          data: { token },
        } = await client.post<LoginResponse>(`${BASE_URL}login`, {
          email,
          password,
        });
        commit('setToken', token);
        setValue(TOKEN, token)
        dispatch('init', null, { root: true });
      } catch (error) {
        commit('setError', true);
      }
    },
    async reset({ commit }, { email, password }: ALoginParams) {
      try {
        const response = await client.post<LoginResponse>(`${BASE_URL}reset`, {
          email,
          password,
        });
        return response;
      } catch (error) {
        commit('setError', true);
      }
    },
    async logout({ commit }) {
      removeValue(TOKEN);
      commit('setToken', null);
    },
    async getUser({ commit }) {
      try {
        const { data } = await client.get('user');
        commit('setUser', data.user);
      } catch (error) {
        commit('setToken', null);
      }
    },
  },
  mutations: {
    setToken(state: IUserState, token: string) {
      state.token = token;
    },
    setUser(state: IUserState, selectedUser: IUser) {
      state.currentUser = selectedUser;
    },
    setError(state: IUserState, error: boolean) {
      state.error = error;
    }
  },
  getters: {
    currentUser({ currentUser }) {
      return currentUser
    },
    modules({ currentUser }: IUserState) {
      const modulePermissions = (currentUser?.role?.modules || []).reduce(
        (acc, item) => {
          // @ts-ignore
          acc[item.name] = item.access;
          return acc;
        },
        {} as Record<string, string>,
      );
      return modulePermissions;
    },
    notifications({ currentUser }: IUserState) {
      return currentUser?.notifications || [];
    },
  },
};
